import { authorizedApiClient } from "../config";
import {
  AddTeamMemberRequest,
  CreateTeamRequest,
  RemoveTeamMemberRequest,
  Team,
  TeamMembership,
  UpdateTeamRequest,
} from "./teamsEndpoints.interface";

export const listTeams = async ({ workspace_id }: { workspace_id: string }) =>
  authorizedApiClient.get<Team[]>(`/${workspace_id}/teams`);

export const createTeam = async ({
  workspace_id,
  name,
  description,
}: CreateTeamRequest) =>
  authorizedApiClient.post<Team>(`/${workspace_id}/teams`, {
    workspace_id,
    name,
    description: description || undefined,
  });

export const updateTeam = async ({
  workspace_id,
  team_id,
  name,
  description,
}: UpdateTeamRequest) =>
  authorizedApiClient.put<Team>(`/${workspace_id}/teams/${team_id}`, {
    name,
    description: description || undefined,
  });

export const deleteTeam = async ({
  workspace_id,
  team_id,
}: {
  workspace_id: string;
  team_id: string;
}) => authorizedApiClient.delete<Team>(`/${workspace_id}/teams/${team_id}`);

export const listTeamMemberships = async ({
  workspace_id,
}: {
  workspace_id: string;
}) => authorizedApiClient.get<TeamMembership[]>(`/${workspace_id}/teams/members`);

export const addTeamMember = async ({
  workspace_id,
  team_id,
  workspace_member_id,
}: AddTeamMemberRequest) =>
  authorizedApiClient.post<TeamMembership>(`/${workspace_id}/teams/${team_id}/members`, {
    team_id,
    workspace_member_id,
  });

export const removeTeamMember = async ({
  workspace_id,
  team_id,
  membership_id,
}: RemoveTeamMemberRequest) =>
  authorizedApiClient.delete<TeamMembership>(
    `/${workspace_id}/teams/${team_id}/members/${membership_id}`,
  );
